export enum LogicRulesNames {
  Equals = 'Equals',
  Exists = 'Exists',
  Contains = 'Contains',

  // String Rules
  Substring = 'Substring',
  EndsWith = 'EndsWith',
  StartsWith = 'StartsWith',
  StringExists = 'StringExists',

  // Date Rules
  Within = 'Within',
  Outside = 'Outside',

  // ordering rules
  GTEQ = '>=',
  GT = '>',
  LT = '<',
  LTEQ = '<=',

  All = 'All',
}

export const notLogicRule = (ruleName: LogicRulesNames): string => `not_${ruleName}`;

export const isRelativeDate = (ruleName: LogicRulesNames): boolean =>
  [LogicRulesNames.Within, LogicRulesNames.Outside].includes(ruleName);
